import BeaconAction from './sdk/tgp_h5_sdk.min';
import PerformanceReport from './core/performance';
import HttpRequestReport from './core/http-request';
import ErrorReport from './core/error-report';
import BehaviourReport from './core/behaviour-report';
import { BeaconInstance, ReportOptions } from './types';

// 默认为 SAAS 服务的上报地址，私有化客户请在此传入您的上报地址
const REPORT_URL = 'https://ubap-report.sany.com.cn/logserver/sdk/analytics/upload?tp=js';

// 上报时的appkey,需要支持环境变量配置
const DATA_INSIGHT_APP_KEY = ''.concat(process.env.DATA_INSIGHT_APP_KEY || '');
const CLIENT_ID = ''.concat(process.env.CLIENT_ID || '');
const isDevMode = (location.host.indexOf('localhost') > -1) || (location.host.indexOf('test') > -1) || (location.host.indexOf('dev') > -1);
const GLOBAL_LABEL = 'GSP_REPORT_INSTANCE';

export default class Report {
  // 性能上报工具
  private performanceReport: PerformanceReport | null = null;

  // http请求上报工具
  private httpRequestReport: HttpRequestReport | null = null;

  // 错误上报工具
  private errorReport: ErrorReport | null = null;

  // 页面行为上报工具
  public behaviourReport: BehaviourReport | null = null;

  // 数据上报埋点工具实例 
  private readonly _beacon: BeaconInstance | null = null;

  // 工具配置
  private static options: ReportOptions = {
    performanceFirstResource: false,
    performanceCore: false,
    performanceServer: false,
    errorServer: false,
    openErrorReport: false,
    openBehaviourReport: false,
  };

  private constructor() {
    if (window?.[GLOBAL_LABEL]) {
      return window?.[GLOBAL_LABEL];
    }

    // this._beacon = new BeaconAction({
    //   appkey: DATA_INSIGHT_APP_KEY, // 数据资源appkey, 必填
    //   reportUrl: REPORT_URL,
    //   versionCode: '', // 项目版本, 选填, 不设置会走默认配置
    //   channelID: CLIENT_ID, // 渠道, 选填, 不设置会走默认配置
    //   openid: '', // 用户 id, 选填, 不设置会走默认配置
    //   delay: 5000, //   普通事件延迟上报时间(单位毫秒), 默认 5000(5 秒),选填
    //   maxDBCount: 10000, // 最大存储条数, 默认 10000(条), 设置区间10000-50000,选填
    //   sessionDuration: 60 * 1000, // session 变更的时间间隔, 一个用户持续 30 分钟(默认值)没有 任何上报则算另一次 session, 每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒 (ms), 最小值 30 秒, 选填, 不设置会走默认配置
    // });
    this._beacon = new BeaconAction({
      appkey: 'L75UNWW5399E6D8C', // 数据资源appkey, 必填
      reportUrl: 'https://ubap-report.sany.com.cn/logserver/analytics/upload?tp=js', // 默认为 SAAS 服务的上报地址，私有化客户请在此传入您的上报地址
      versionCode: '', // 项目版本, 选填, 不设置会走默认配置
      channelID: '', // 渠道, 选填, 不设置会走默认配置
      openid: '', // 用户 id, 选填, 不设置会走默认配置；上报到平台后对应为uid字段
      delay: 5000, // 普通事件延迟上报时间(单位毫秒), 默认 5000(5 秒),选填
      maxDBCount: 10000, // 最大存储条数, 默认 10000(条), 设置区间10000-50000,选填
      sessionDuration: 60 * 1000, // session 变更的时间间隔, 一个用户持续 30 分钟(默认值)没有 任何上报则算另一次 session, 每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒 (ms), 最小值 30 秒, 选填, 不设置会走默认配置
      // onReportSuccess: success, // 上报成功回调, 选填, 不设置会走默认配置
      // onReportFail: fail, // 上报失败回调, 选填, 不设置会走默认配置
    });
    const {
      performanceFirstResource,
      performanceCore,
      performanceServer,
      errorServer,
      openErrorReport,
      openBehaviourReport,
    } = Report.options;
    this.performanceReport = new PerformanceReport(this._beacon!);
    this.httpRequestReport = new HttpRequestReport(this._beacon!);
    this.errorReport = new ErrorReport(this._beacon!);
    this.behaviourReport = new BehaviourReport(this._beacon!);
    this.performanceReport.init({ performanceFirstResource, performanceCore });
    this.httpRequestReport.init({ performanceServer, errorServer });
    this.errorReport.init({ openErrorReport });
    this.behaviourReport.init({ openBehaviourReport });
    if (!window?.[GLOBAL_LABEL]) {
      (window as any)[GLOBAL_LABEL] = this;
    }
    return (window as any)[GLOBAL_LABEL];
  }

  public startReport() {
    const report = new Report();
    // 开发模式和没有配置APP_KEY则直接停止上报
    if (isDevMode) {
      // if (isDevMode || !DATA_INSIGHT_APP_KEY) {
      report._beacon!.stopReport(true);
    }
    return report;
  }

  public static config(options: ReportOptions) {
    // 设置配置
    Object.keys(options).forEach((key) => {
      if (key in Report.options) {
        Report.options[key] = options[key];
      }
    });
  }

  public static get instance() {
    return new Report();
  }

  /**
   * 必须要在startReport后调用，否则这里为空对象
   */
  public get beacon() {
    return Report.instance._beacon!;
  }
}

export * from './utils/special-report';
